

function initCollapse() {
  $('.collapse').each(function (index, element) {
    $(element).collapse({toggle: false});
    $('[data-target="#' + element.id + '"]').on('click', function () {
      $(element).collapse('toggle');
    });
  });
}

function initPopup() {
  // make popup work with instantclick
  var imgLinks = document.querySelectorAll('a[href$=".jpg"],a[href$=".jpeg"],a[href$=".png"]');
  for (var i = 0; i < imgLinks.length; i++) {
    imgLinks[i].setAttribute('data-no-instant', true);
  }
  // init magnific popup
  $(imgLinks).magnificPopup({
    type: 'image',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [1, 2],
      tCounter: ''
    },
    image: {
      titleSrc: function(item) {
        return item.el.parent().find('figcaption').html();
      }
    }
  });
}


function initBackground() {
  var nr = Math.floor(Math.random()*bgs.length);
  var src = bgs[nr];
  var img = new Image();
  var node = document.querySelector('.background');
  img.onload = function() {
    if (document.body.contains(node)) {
      node.style.backgroundImage = 'url(' + src + ')'
    }
  };
  img.src = src;
}

function init() {
  initCollapse();
  initPopup();
  initBackground();
}

init();
